(function ($) {
    $(window).on('load', function () {
        if ($('.house-selection').length) {
            $('.house-selection').scrollLeft(($('.house-selection .background-image').width() - window.innerWidth) / 2)
        }
    })

    if ($('.house-summary-modal').length) {
        const houseSummarySwiper = new Swiper('.house-summary-modal .house-summary-swiper', {
            autoHeight: true,
            loop: false,
            keyboard: {
                enabled: true,
                onlyInViewport:true,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            observer: true,
            observeParents: true,
            preventClicksPropagation: false,
            a11y: false,
            slidesPerView: 'auto', spaceBetween: 25,
            noSwipingSelector: 'a',
            simulateTouch: false

        });
        houseSummarySwiper.on('slideChange', function () {
            if (window.location.hash.includes("house-modal")) {
                window.location.hash = `house-modal-${$(this.slides[this.activeIndex]).data('building-id')}`
            }
        });

        if (window.location.hash.includes("house-modal")) {
            $('body').addClass('overflow-hidden');
            $('.house-summary-modal').addClass('active');
        }

        $(window).on('hashchange', function() {
            if (window.location.hash.includes("house-modal")) {
                if (!window.location.hash) {
                    $('.house-summary-modal').removeClass('active');
                    $('body').removeClass('overflow-hidden');
                } else {
                    const buildingId = window.location.hash.split('house-modal-')[1];

                    if (buildingId) {
                        houseSummarySwiper.slideTo($(`.house-summary-swiper .swiper-slide[data-building-id=${buildingId}]`).index(), 0);
                        window.location.hash = `house-modal-${buildingId}`;
                        $('.house-summary-modal').addClass('active');
                        $('body').addClass('overflow-hidden');
                    }
                }
            }
        })
        if (window.location.hash.includes("house-modal")) {
            $('body').addClass('overflow-hidden');
            $('.house-summary-modal').addClass('active');
            const targetModalSlide = window.location.hash.split("house-modal-")[1];

            setTimeout(function() {
                houseSummarySwiper.slideTo($(houseSummarySwiper.slides).filter(`[data-building-id=${targetModalSlide}]`).index(), 0);
            }, 1)
        }

        $('.house-selection .house-marker').on('click', function() {
            const disableModal = $(this).hasClass('js-modal-false');
            const forwardToUrl = $(this).data('liven-redirect');

            if ( forwardToUrl ) {
                window.location.href = forwardToUrl; 
            } else {
                if ( !disableModal ) {
                    const buildingId = $(this).data('building-id');
                    $('body').addClass('overflow-hidden');
                    window.location.hash = `house-modal-${buildingId}`;
                    $('.house-summary-modal').addClass('active');
                    houseSummarySwiper.slideTo($(`.house-summary-swiper .swiper-slide[data-building-id=${buildingId}]`).index(), 0);
                }
            }
        });

        $('.house-summary-modal .close-button').on('click',function(){
            $('.house-summary-modal.active').removeClass('active');
            $('body.overflow-hidden').removeClass('overflow-hidden');
            window.history.pushState('', '/', window.location.pathname)
        })
        $(document).on('keyup',function(evt) {
            if (evt.keyCode === 27) {
                $('.house-summary-modal.active').removeClass('active');
                $('body.overflow-hidden').removeClass('overflow-hidden');
                window.history.pushState('', '/', window.location.pathname)
            }
        });
    }

    if ($('.house-selection').length)  {
        $('body').on('click','.house-selection .info-marker',function(e){

            if($(this).hasClass('not-clickable')) {
                e.preventDefault();
            }else{
                $('.modal-info-marker').addClass('active');
                $('.modal-info-marker').addClass('loading');
                const slideIndex = $(this).data('slide-index');
                let modal = $(this).data('modal');
                window.location.hash = $(this).data('gallery');

                const data = {
                    'action': 'info_marker_modal',
                    'modal_number': modal,
                    'slide_index': slideIndex,
                };
                ajaxCall(data,slideIndex);
            }
        })
        const modalInfoMarkerSwiper = new Swiper('.modal-info-marker .modal-nature-swiper.info-marker-slide', {
            spaceBetween: 30,
            autoHeight: true,
            loop: false,
            keyboard: {
                enabled: true,
                onlyInViewport:true,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            observer: true,
            observeParents: true,
            simulateTouch: false

        });
        function ajaxCall(data,slideIndex) {

            $.get(liven.ajax_url, data, function (response) {

                $('.swiper.modal-nature-swiper.info-marker-slide .swiper-wrapper').append(response.data.modal);

                $('.modal-info-marker').removeClass('loading');
                if (response.success) {

                    modalInfoMarkerSwiper.on('slideChange', function () {
                        if (window.location.hash.includes("nature-modal")) {
                            window.location.hash = `nature-modal-${$(this.slides[this.activeIndex]).data('slide-id')}`
                        }
                    });
                    // modalInfoMarkerSwiper.slideTo(slideIndex)
                    $('.modal-info-marker').addClass('active');
                    $('body').addClass('overflow-hidden');
                    $(window).on('hashchange', function() {
                        if (window.location.hash.includes("nature-modal")) {
                            if (!window.location.hash) {
                                $('.modal-info-marker ').removeClass('active');
                                $('body').removeClass('overflow-hidden');
                            } else {
                                const targetWorker = window.location.hash.split('nature-modal-')[1];
                                if (targetWorker) {
                                    modalInfoMarkerSwiper.slideTo($(modalInfoMarkerSwiper.slides).filter(`[data-gallery=${targetWorker}]`).index(), 0);
                                    window.location.hash = `nature-modal-${targetWorker}`;
                                    $('.modal-info-marker').addClass('active');
                                    $('body').addClass('overflow-hidden');
                                }
                            }
                        }
                    })

                    if (window.location.hash.includes("nature-modal")) {
                        $('body').addClass('overflow-hidden');
                        $('.modal-info-marker').addClass('active');
                        const targetWorker = window.location.hash.split("nature-modal-")[1];

                        setTimeout(function() {
                            modalInfoMarkerSwiper.slideTo($(modalInfoMarkerSwiper.slides).filter(`[data-gallery=${targetWorker}]`).index(), 0);
                        }, 1)
                    }

                    $('body').on('click','.modal-info-marker .close-button',function(e){
                        $('.modal-info-marker.active').removeClass('active');
                        $('body.overflow-hidden').removeClass('overflow-hidden');
                        window.history.pushState('', '/', window.location.pathname)
                        modalInfoMarkerSwiper.removeAllSlides();
                    })
                    $(document).on('keyup',function(evt) {
                        if (evt.keyCode === 27) {
                            $('.modal-info-marker.active').removeClass('active');
                            $('body.overflow-hidden').removeClass('overflow-hidden');
                            window.history.pushState('', '/', window.location.pathname)
                            modalInfoMarkerSwiper.removeAllSlides();
                        }
                    });
                    if($('.modal-info-marker .swiper-slide.faq-slide-type.swiper-slide-active')) {
                        $('.modal-info-marker .faq-block .question').each(function( index ) {
                            let faqHeight = $(this).parents('.faq-block').height();
                            $(this).siblings('.answer').hide();
                            $(this).on('click', function () {
                                $(this).parent().toggleClass('active').find('.answer').slideToggle();
                                if($(this).parents('.faq-block').hasClass('active')) {
                                    $(this).parents('.swiper-wrapper').siblings('.swiper-buttons').animate({marginTop: faqHeight + 30}, 600, function () {
                                    });
                                }else {
                                    $(this).parents('.swiper-wrapper').siblings('.swiper-buttons').animate({marginTop: 56}, 600, function () {
                                    });
                                }
                            })
                        });
                    }
                }
            });
        }

        if (window.location.hash.includes("nature-modal")) {
            $('.modal-info-marker').addClass('loading');

            let slide = window.location.hash.split("nature-modal-")[1].split("-")[1];
            let modal = window.location.hash.split("nature-modal-")[1].split("-")[0];
            const data2 = {
                'action': 'info_marker_modal',
                'modal_number': modal,
                'slide_index': slide,
            };
            ajaxCall(data2,slide);
        }

    }

    /**
     * Close modal if clicking browser back button and theres no hash in URL
     */
    $(window).on('popstate', function(event) {
        // Close info marker modal
        if( !window.location.hash && $('.modal-info-marker').hasClass('active') ) {
            $('.modal-info-marker').find('.close-button').trigger('click');
        }
        // Close house modal
        if( !window.location.hash && $('.house-summary-modal').hasClass('active') ) {
            $('.house-summary-modal').find('.close-button').trigger('click');
        }

        // If undefined then close all modals
        if( window.location.hash ) {
            if( window.location.hash.split("nature-modal-")[1] == 'undefined' ) {
                $('.modal-info-marker').find('.close-button').trigger('click');
                $('.house-summary-modal').find('.close-button').trigger('click');
            }
        }
    });

})(jQuery);